export const PRODUCT_GRID_REDUCED_PRICE_FLAG = 'product-grid.reduced-price-flag';
